import ConfigDB from './data/customizer/theme';

const colorPrimary = ConfigDB?.data?.color?.primary_color;
const colorSecondary = ConfigDB?.data?.color?.secondary_color;
const fontFamily = ConfigDB?.data?.fontFamily;
const semiBold = ConfigDB?.data?.semi_bold;

const themeConfig = {
  hashed: false,
  cssVar: { key: 'oms' },
  token: {
    fontFamily: fontFamily,
    colorPrimary,
    colorLink: colorSecondary,
    colorLinkHover: 'color-mix(in srgb, var(--ant-color-secondary), #fff 21%)',
    colorPrimary5: 'color-mix(in srgb, var(--ant-color-primary) 5%, #fff)',
    colorPrimary10: 'color-mix(in srgb, var(--ant-color-primary) 10%, #fff)',
    colorSecondary: colorSecondary,
    colorSecondary5: 'color-mix(in srgb, var(--ant-color-secondary) 5%, #fff)',
    colorSecondary10: 'color-mix(in srgb, var(--ant-color-secondary) 10%, #fff)',
    colorBgContainerDisabled: 'rgba(0, 0, 0, 0.08)',
    borderRadius: 4,
    borderRadiusSM: 4,
    borderRadiusLG: 4,
    colorBorder: 'var(--gray-200)',
    colorTextPlaceholder: 'var(--gray-300)',
    fontSizeLG: 14,
    fontSize16: 16,
    controlHeightSM: 28,
    controlOutline: 'none',
    fontWeight600: semiBold,
  },
  components: {
    Layout: {
      bodyBg: 'transparent',
      headerBg: 'var(--ant-color-bg-base)',
      headerPadding: 60,
    },
    Input: {
      paddingBlock: 8,
      paddingBlockSM: 4,
      activeBorderColor: colorSecondary,
      hoverBorderColor: colorSecondary,
    },
    Select: {
      colorPrimaryHover: colorSecondary,
      optionSelectedBg: 'var(--ant-color-primary-10)',
    },
    Table: {
      headerBg: 'var(--gray-100)',
      borderColor: 'var(--gray-200)',
      headerSplitColor: '#0000000F',
      rowSelectedBg: 'var(--ant-color-white)',
      rowSelectedHoverBg: 'var(--ant-table-row-hover-bg)',
    },
    Button: {
      defaultShadow: 'none',
      dangerShadow: 'none',
      primaryShadow: 'none',
      fontWeight: '600',
      marginXS: 4,
      paddingInlineSM: 16,
      activeShadow: 'none',
    },
    Modal: {
      contentPadding: 0,
      headerMarginBottom: 0,
      headerPadding: '16px 24px',
      headerBorderBottom: '1px solid var(--gray-200)',
      bodyPadding: 24,
      footerMarginTop: 0,
      footerPadding: '16px 24px',
      footerBorderTop: '1px solid var(--gray-200)',
    },
    Tag: {
      fontSizeSm: 14,
      marginXs: 0,
    },
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 0,
      margin: 0,
    },
    Rate: {
      starColor: '#ffce32',
      starBg: 'var(--gray-200)',
      starSize: 'var(--star-size, 16px)',
      marginXs: 'var(--ant-margin-xxs)',
    },
    Tooltip: {
      paddingSm: 24,
      paddingXs: 12,
    },
    Card: {
      headerFontSize: 16,
      fontWeightStrong: 700,
    },
    DatePicker: {
      cellActiveWithRangeBg: 'var(--ant-color-primary-10)',
      activeBorderColor: colorSecondary,
      hoverBorderColor: colorSecondary,
    },
    TreeSelect: {
      nodeSelectedBg: 'var(--ant-color-primary-10)',
    },
  },
};

export default themeConfig;
